var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{staticClass:"noprogress",scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('qic_user_qid_header'))+" ")]},proxy:true}])},[_c('UserIdForm',{on:{"onSubmit":_vm.onSubmit},model:{value:(_vm.qid),callback:function ($$v) {_vm.qid=$$v},expression:"qid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }